import React from "react";
import { useTranslation } from "react-i18next";
import { Box, useTheme } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import Button from "components/basic/button";
import Typography from "components/basic/typography";

interface MeetingsHeaderProps {
  onExport: () => void;
}

const MeetingsHeader: React.FC<MeetingsHeaderProps> = ({ onExport }) => {
  const theme = useTheme();
  const { t } = useTranslation("meetings");

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: 1,
        mb: 1.5,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h3" style={{ fontWeight: 700 }}>
          {t("header.title")}
        </Typography>
        <Typography
          variant="caption"
          style={{ color: theme.palette.text.secondary }}
        >
          {t("header.subtitle")}
        </Typography>
      </Box>
      <Button
        variant="outlined"
        color="primary"
        startAdornment={<FileDownloadOutlinedIcon fontSize="small" />}
        onClick={onExport}
      >
        {t("header.export")}
      </Button>
    </Box>
  );
};

export default MeetingsHeader;
